import "./index.css";
import React from "react";
import { Button, Tooltip } from "antd";

import ICON_WARNING from "../../../assets/warning.svg";

import type { TypeGuidelineCheckboxProps } from "../GuidelineCheckbox";

interface TypeGuidelinesSelectButtonProps
  extends Pick<TypeGuidelineCheckboxProps, "disabled"> {
  /**
   * @param count 选择了多少个 “Guideline”
   */
  count: number;
  /**
   * @param showBtn 是否显示 “Save this selection” 按钮
   */
  showBtn: boolean;
  onClick(): void;
}
const GuidelinesSelectButton: React.FC<TypeGuidelinesSelectButtonProps> = ({
  showBtn,
  onClick,
  disabled,
  count = 0,
}) => (
  <div className="guidelines-select-btn">
    <Tooltip
      title={
        disabled ? "Some guidelines are temporarily unavailable." : undefined
      }
    >
      <span style={{ color: !showBtn || count ? "" : "#d9d9d9" }}>
        {disabled ? <img src={ICON_WARNING} /> : null}
        {count} Selected
      </span>
    </Tooltip>
    {showBtn ? (
      <Tooltip
        placement="bottom"
        title={count ? "Save frequently used guidelines" : ""}
      >
        <Button
          onClick={onClick}
          disabled={!count}
          className={count ? "guidelines-select-ghost-btn" : ""}
        >
          Save this selection
        </Button>
      </Tooltip>
    ) : null}
  </div>
);

export default GuidelinesSelectButton;
